import { DropDownOption } from "../../model/interfaces/drop-down-option.interface";
import { BackTestingDataColumns, BacktestedProbabilityOfLossColumns, ForwardLookingProbabilityOfLossColumns, ForwardTestingDataColumns, PRIIPsCostsColumns, PRIIPsReturnScenariosColumns, PRIIPsSummaryColumns, ProbabilityOfLossColumns, ProbabilityOfReturnsColumns, RiskRewardColumns, ValueForMoneyCloudRiskColumns, ValueForMoneyFVCColumns } from "./analytics-table-columns.const";

export enum AnalyticsReportsTypes {
    STRESS = 'STRESS',
    PRIIPS = 'PRIIPS'
}

export const ANALYTICS_REPORTS_TYPES: DropDownOption[] = [
    { id: AnalyticsReportsTypes.STRESS, displayValue: 'Stress Testing' },
    { id: AnalyticsReportsTypes.PRIIPS, displayValue: 'PRIIPs' },
];

export const AnalyticsReportsColumns = {
    STRESS_TESTING: {
        backTestingData: BackTestingDataColumns,
        forwardTestingData: ForwardTestingDataColumns,
        probabilityOfReturns: ProbabilityOfReturnsColumns,
        backtestedProbabilityOfLoss: BacktestedProbabilityOfLossColumns,
        forwardLookingProbabilityOfLoss: ForwardLookingProbabilityOfLossColumns,
        riskReward: RiskRewardColumns,
        valueForMoneyFVC: ValueForMoneyFVCColumns,
        probabilityOfLoss: ProbabilityOfLossColumns,
        valueForMoneyCloudRisk: ValueForMoneyCloudRiskColumns
    },
    PRIIPS: {
        priipsSummary: PRIIPsSummaryColumns,
        priipsReturnScenarios: PRIIPsReturnScenariosColumns,
        priipsCosts: PRIIPsCostsColumns
    }
}